(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputDualListbox', cpInputDualListbox);

    cpInputDualListbox.$inject = ['$templateRequest', '$compile', '$timeout'];

    function cpInputDualListbox($templateRequest, $compile, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-dual-listbox/input-dual-listbox.html',
            scope: {
                title: '@',
                opts: '=',

                optsPropValue: '@',
                optsPropTitle: '@',
                optsPropExtraValue: '@',
                optsPropExtraTitle: '@',
                optsModel: '=',
                optsOnChange: '&?',

                suboptsKey: '@?',
                suboptsPropValue: '@?',
                suboptsPropTitle: '@?',
                suboptsModel: '=?',
                suboptsModelProp: '@?',
                suboptsModelSubprop: '@?',
                suboptsOnChange: '&?',
                suboptsSelectedAll: '@?',

                suboptsOnDetail: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getPropTitle = getPropTitle;

                function getPropTitle(opt) {
                    var title = '[' + opt[scope.optsPropValue] + '] ' + opt[scope.optsPropTitle];

                    if (scope.optsPropExtraTitle) {
                        title = opt[scope.optsPropExtraTitle] + ' ' + title;
                    }

                    if (scope.optsPropExtraValue) {
                        title = '[' + opt[scope.optsPropExtraValue] + '] ' + title;
                    }

                    return title;
                }

                /* currently hovered option */
                scope.currentOpt = {};

                /* helpers */
                scope.isSuboptChecked = isSuboptChecked;
                scope.runSuboptsOnChange = runSuboptsOnChange;
                scope.runOptsOnChange = runOptsOnChange;

                scope.settings = {
                    bootstrap2: false,
                    postfix: '_helperz',
                    selectMinHeight: 404,
                    filter: true,
                    filterClear: 'Pokaż wszystkie!',
                    filterPlaceHolder: 'Filtruj!',
                    filterValues: true,
                    filterNonSelected: '',
                    filterSelected: '',
                    moveOnSelect: true,
                    moveSelectedLabel: 'Przenieś tylko wybrane!',
                    moveAllLabel: 'Przenieś wszystkie!',
                    removeSelectedLabel: 'Usuń tylko wybrane',
                    removeAllLabel: 'Usuń wszystkie!',
                    preserveSelection: 'moved', // 'all'
                    selectedListLabel: 'Wybrane',
                    nonSelectedListLabel: 'Nie wybrane',
                    infoAll: 'Wszystkie {0}!',
                    infoFiltered: '<span class="label label-warning">Odfiltrowane</span> {0} z {1}!',
                    infoEmpty: 'Pusta lista!'
                };

                /**
                 * Popover configuration.
                 */
                var hidePopoverAfter = 1000,
                    showPopoverAfter = 500,
                    popoverContentTmpl = 'app/caffeprint/directives/input-dual-listbox/input-dual-listbox-popover-template.html';

                var timerSelect,
                    timerPopover,
                    selected,
                    target,
                    template,
                    title,
                    value;

                function isSubopts() {
                    /**
                     * Check if suboptions exist in current directive instance.
                     */
                    return scope.suboptsKey && scope.suboptsPropValue && scope.suboptsPropTitle;
                }

                function _getSuboptsModelItem() {
                    /**
                     * Get ``subopt`` model object which is currently shown in popover.
                     */
                    return scope.suboptsModel.find(function(item) {
                        return scope.currentOpt[scope.suboptsPropValue] === item[scope.suboptsModelProp];
                    });
                }

                function isSuboptChecked(subopt) {
                    /**
                     * Returns ``true`` if given ``subopt`` is selected.
                     */
                    var suboptsModelItem = _getSuboptsModelItem();
                    return suboptsModelItem[scope.suboptsModelSubprop].indexOf(subopt[scope.suboptsPropValue]) !== -1;
                }

                function runSuboptsOnChange(subopt, value) {
                    /**
                     * Evaluated when some ``subopt`` has been chekced/unchecked
                     */
                    var suboptsModelItem = _getSuboptsModelItem();

                    if (value) {
                        suboptsModelItem[scope.suboptsModelSubprop].push(subopt[scope.suboptsPropValue]);
                    } else {
                        var index = suboptsModelItem[scope.suboptsModelSubprop].indexOf(subopt[scope.suboptsPropValue]);
                        suboptsModelItem[scope.suboptsModelSubprop].splice(index, 1);
                    }

                    if (scope.suboptsOnChange) {
                        scope.suboptsOnChange();
                    }
                }

                function runOptsOnChange() {
                    /**
                     * Evaluated when some ``opt`` has been selected/unselected.
                     */
                    if (isSubopts()) {
                        var oldOptsModel = scope.suboptsModel.map(function(item) {
                            return item[scope.suboptsModelProp];
                        });

                        var addedOpt = scope.optsModel.filter(function(item) {
                            return oldOptsModel.indexOf(item) === -1;
                        });

                        var deletedOpt = oldOptsModel.filter(function(item) {
                            return scope.optsModel.indexOf(item) === -1;
                        });

                        for (var i = 0; i < addedOpt.length; ++i) {
                            var tmp = {};
                            tmp[scope.suboptsModelProp] = addedOpt[i];

                            if (scope.suboptsSelectedAll) {
                                var tmpAddedOptInstance = scope.opts.find(function(item) {
                                    return item[scope.optsPropValue] === addedOpt[i];
                                });

                                tmp[scope.suboptsModelSubprop] = tmpAddedOptInstance[scope.suboptsKey].map(function(item) {
                                    return item[scope.suboptsPropValue];
                                });
                            } else {
                                tmp[scope.suboptsModelSubprop] = [];
                            }

                            scope.suboptsModel.push(tmp);
                        }

                        for (var j = 0; j < deletedOpt.length; ++j) {
                            var tmpObj = scope.suboptsModel.find(function(item) {
                                return item[scope.suboptsModelProp] === deletedOpt[i];
                            });
                            var index = scope.suboptsModel.indexOf(tmpObj);
                            scope.suboptsModel.splice(index, 1);
                        }
                    }

                    if (scope.optsOnChange) {
                        scope.optsOnChange();
                    }
                }

                if (isSubopts()) {
                    $timeout(function() {
                        selected = element.find('#bootstrap-duallistbox-selected-list_');

                        selected.on('mouseleave', function(event) {
                            $timeout.cancel(timerSelect);
                            $timeout.cancel(timerPopover);
                            timerSelect = $timeout(function() {
                                selected.popover('destroy');
                            }, hidePopoverAfter);
                        });

                        selected.on('mouseover', function(event) {
                            target = angular.element(event.target);
                            if (target.is('option')) {
                                title = target[0].label;
                                value = target[0].value;

                                scope.currentOpt = scope.opts.find(function(item) {
                                    return getPropTitle(item) === title;
                                });

                                $timeout.cancel(timerSelect);
                                $timeout.cancel(timerPopover);
                                selected.popover('destroy');

                                $templateRequest(popoverContentTmpl).then(function(html) {
                                    template = angular.element(html);
                                    template = $compile(template)(scope);

                                    $timeout(function() {
                                        selected.popover({
                                                trigger: 'manual',
                                                placement: 'left',
                                                html: true,
                                                title: title,
                                                content: template
                                            })
                                            .popover('show');

                                        angular.element('.popover')
                                            .on("mouseover", function() {
                                                $timeout.cancel(timerSelect);
                                                $timeout.cancel(timerPopover);
                                            })
                                            .on("mouseleave", function() {
                                                $timeout.cancel(timerPopover);
                                                $timeout.cancel(timerSelect);
                                                timerPopover = $timeout(function() {
                                                    selected.popover('destroy');
                                                }, hidePopoverAfter);
                                            });
                                    }, showPopoverAfter);
                                });
                            }
                        });
                    });
                }
            }
        };
    }
})();
